export const SHOP_TO_CLUB_NAVIGATION_KEY = 'shopToClubNavigation';
export const CART_PRODUCT_LINK = 'cartProductLink';

interface NavigationPayload {
    type: string;
    data?: {
        from?: string;
    };
}

export const handleBackButtonClick = () => {
    const navigation = window.sessionStorage.getItem(SHOP_TO_CLUB_NAVIGATION_KEY);
    let redirectTo = '';

    if (navigation) {
        try {
            const { type: navigationType, data } = JSON.parse(navigation) as NavigationPayload;
            if (navigationType === CART_PRODUCT_LINK) {
                redirectTo = data?.from || '';
            }
        } catch (e) {
            redirectTo = '';
        } finally {
            window.sessionStorage.removeItem(SHOP_TO_CLUB_NAVIGATION_KEY);
        }

        if (redirectTo) {
            window.location.href = redirectTo;
            return;
        }
    }

    window.history.back();
};
